
import React, { useEffect, useState, useRef } from 'react';
//import { Col, Container, Row } from "reactstrap";
import { Activatetitle } from "../../utils/Constant";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import { decryptData } from "../../utils/helper/Crypto";
import DataTable from "react-data-table-component";
import { Container,Card, CardBody, Col, Row, Form, FormGroup, Input, Label, } from "reactstrap";
import { Btn, Image } from "../../AbstractElements";
import { useSweetAlert } from '../../Context/SweetAlertContext'
import { useActivationService } from '../../Service/Activation/Activation';
import { IoMdPrint } from "react-icons/io";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import Datanotfound from '../../Component/PageNotFound/Datanotfound'
import { BulkActivationColumn } from '../../Data/TableData/TableData';
import { dynamicImage } from '../../Service';

const BulkActivation = () => {
  const { ExecuteProcedure,loading } = useActivationService();
  const { showAlert, ShowSuccessAlert, ShowConfirmAlert } = useSweetAlert();
  const [ClientID, setClientID] = useState(decryptData(localStorage.getItem("clientId") as string));
  const [PackagesList, setPackagesList] =useState<any>([])
  const [TotalValue, setTotalValue] = useState<any>(0)
  useEffect(() => {
    GetPackage();
  }, []);

  
      const GetPackage = async () => {
          const param = {
              ClientId: ClientID,
              ActionMode: "GetPackage"
          }
          const obj = {
              procName: 'ManagePackage',
              Para: JSON.stringify(param),
          };
          const res = await ExecuteProcedure(obj);
          if(res!='NoRecord'){
            setPackagesList(res);
          }
          else{
            setPackagesList([]);
          }
          
      }

      const handleActivation = async () => {
        const confirmed = await ShowConfirmAlert("Activate Bot", "Are you sure want to activate");
        if (confirmed) {
            // const param = {
            //     ClientId: ClientID,
            //     Packageid: WalletType
            // }
            // const res = await doActivation(param);
            // if (res[0].StatusCode == "1") {
            //     ShowSuccessAlert("Bot Activated Successfully");
            //     refreshAction(true);
            // } else {
            //     showAlert(res[0].Msg);
            // }
        } else {
            // console.log('do nothing.');
        }
    }

    // Select table values 
    const handleSelectedRowsChange = (data: { selectedRows: any[];}) => {
        const  {selectedRows } = data
        const sorteddata =  selectedRows.map((itm:any)=> +itm?.PackageName?.replace(/[^\d]/g, ''))
        const initialValue = 0;
        const sumWithInitial = sorteddata.reduce((accumulator, currentValue) => accumulator + currentValue,
            initialValue,);
        setTotalValue(sumWithInitial)
        console.log("Selected Rows:", data.selectedRows, sorteddata, sumWithInitial);
      };

   // Table Footer
      const CustomPagination = () => {
        return <div style={{ backgroundColor:'#030a26', padding:'10px 5px', color:'#fff' }}>
            Total Amount : {TotalValue}
            <Btn color='btn btn-primary ms-3'>Pay Amount</Btn>
            </div>;
      };
      
  return (
    <>
      <Breadcrumbs mainTitle={Activatetitle} parent={Activatetitle} />
      <Container fluid>
        <Row>
          <Col xl="12">
          <Form>
            {/* {loading && <Loader />} */}
            <button className="btn-info py-2 pe-2" color="info" style={{ fontSize: '18px', textAlign: 'justify', width: '210px' }} type="button">
                Wallet Balance :
                {loading ? <div className="spinner-border text-light text-center" style={{ width: '1rem', height: '1rem' }} role="status">
                </div> : <span> &nbsp;3333</span>}
            </button>
            <hr />
          </Form> 
          </Col>
          <Col md="6" className="table-responsive data-table">
          <DataTable
                data={PackagesList}
                columns={BulkActivationColumn}
                pagination
                paginationComponent={CustomPagination} // Use Custom Footer
                selectableRows 
                onSelectedRowsChange={handleSelectedRowsChange} 
                // subHeaderComponent={}
                customStyles={{
                  table: {
                    style: {
                      backgroundColor:'#020a29',
                      fontSize: '15px',
                    }
                  },
                  headCells: {
                    style: {
                      backgroundColor:'#3bf7ee',
                      fontSize: '15px',
                      color:'#000',
                      fontWeight:600
                    }
                  },
                  rows: {
                    style: {
                      backgroundColor:'#030a26',
                      fontSize: '15px',
                      color:'#fff',
                    }
                  },
                  subHeader: {
                    style: {
                      backgroundColor: '#3bf7ee', // Set the background color for the subheader
                      color: '#fff', // Set text color for subheader
                      padding: '1px', // Optional padding
                    },
                  },
                }}
                paginationPerPage={15} 
                noDataComponent={<Datanotfound />}
              />
          </Col>
          <Col md="6" className='d-none d-md-block'>
                <Image src={dynamicImage('BulkActivation_img.svg')} className='w-100' alt=""/>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default BulkActivation;

